import pick from "lodash/pick";
import get from "lodash/get";
import { ipAddress, required } from "vuelidate/lib/validators";
import { crudState } from "@/vue/utils/helper";
import { getEnv } from "@/env";

export const PROXY_SERVER = "eps1.packet8.net:5060";

export const newTrunkGateway = () => ({
  name: null,
  brand: "gtg",
  proxyServer: PROXY_SERVER,
  boxes: [newIpBox()],
  additionalBoxes: [],
  subscriberDetails: {
    firstName: null,
    lastName: null,
    email: null,
    serviceCountry: null,
    brandId: getEnv("VUE_APP_NODE_ENV") === "production" ? 50 : 1,
  },
});

export const newIpBox = () => ({
  ipAddress: null,
  protocol: "UDP",
  port: 5060,
  priority: 10,
  weight: 10,
});
export const ipBoxValidation = () => ({
  ipAddress: { required, ipAddress },
  protocol: { required },
  port: { required },
  priority: { required },
  weight: { required },
});

export const newGatewayDid = (trunkId) => ({
  trunkId,
  address: "",
  state: crudState(),
  didDto: {
    didId: null,
    addressId: null,
    phoneNumber: null,
    emergencyDetails: {
      firstName: null,
      lastName: null,
      email: null,
    },
  },
});

export const didDtoUpdateMap = (didDto) =>
  pick(didDto, [
    "licenseId",
    "phoneNumber",
    "tollFree",
    "didId",
    "addressId",
    "emergencyDetails",
    "createdOn",
    "lastUpdate",
  ]);

export const smartyToValidationDto = (response) => {
  if (!response.data.success) {
    throw new Error(
      `Expected validation success, got:\n${JSON.stringify(response)}`
    );
  }
  const address = get(
    response.data,
    "success[0].resultPayload.suggestedAddress"
  );
  if (!address) {
    throw new Error(
      `Could not parse freeForm response:\n${JSON.stringify(
        response.data.success
      )}`
    );
  }
  return pick(address, [
    "streetNumber",
    "streetName",
    "city",
    "state",
    "country",
    "postal",
    "county",
    "zip4",
  ]);
};
